export default function ProgressBar({ barColor, completePercent }) {
  return (
    <div className="relative h-3 max-w-xl overflow-hidden rounded-full">
      <div className="absolute w-full h-full bg-gray-300"></div>
      <div className={`h-full absolute ${barColor}`} style={{ width: `${completePercent}%` }}></div>
    </div>
  )
}
